export const mask = [
    "5009223",
    "108280",
    "7343924",
    "112253",
    "112385",
    "5250708",
    "122469",
    "3877670",
    "115974",
    "104024",
    "106936",
    "109202",
    "7514159",
    "7308180",
    "107914",
    "7292841",
    "5295367",
    "1855980",
    "4418980",
    "122328",
    "7587503",
    "241108",
    "107095",
    "111335",
    "7587468",
    "200167",
    "128209",
    "120291",
    "104155",
    "116745",
    "127677",
    "127769",
    "127480",
    "5662236",
    "6728873",
    "107001",
    "116238",
    "2448638",
    "114774",
    "122243",
    "7587687",
    "112528",
    "242124",
    "104966",
    "122306",
    "5548341",
    "110722",
    "120531",
    "3664735",
    "129966",
    "129934",
    "110320",
    "117143",
    "7529760",
    "115959",
    "7587649",
    "117028",
    "104817",
    "112636",
    "130357",
    "241726",
    "100137",
    "126570",
    "111075",
    "243011",
    "7426079",
    "116939",
    "111246",
    "5617485",
    "106541",
    "105390",
    "127455",
    "110200",
    "104353",
    "108817",
    "7307592",
    "117612",
    "129236",
    "112609",
    "7307673",
    "114822",
    "115329",
    "126814",
    "127227",
    "124234",
    "124784",
    "123361",
    "122799",
    "123102",
    "122552",
    "6336147",
    "103150",
    "103846",
    "106429",
    "107573",
    "7587170",
    "109374",
    "111280",
    "111434",
    "7657322",
    "100460",
    "4429676",
    "118372",
    "128870",
    "115112",
    "101674",
    "4440514",
    "115202",
    "7587332",
    "108474",
    "100141",
    "102259",
    "110544",
];
